<script>
export default {
  name: 'ProductListPlaceholder',
};
</script>

<template>
  <table class="w-full table-fixed mt-6">
    <thead class="border-b border-gray-100">
    <tr>
      <th class="w-1/3 md:w-4/12 text-left pl-2 md:pl-3 py-4">
        <div class="h-4 bg-gray-200 rounded my-2 animate-pulse"></div>
      </th>
      <th class="w-1/3 md:w-3/12 text-left pl-2 md:pl-3 py-4">
        <div class="h-4 w-24 bg-gray-200 rounded animate-pulse"></div>
      </th>
      <th class="w-1/3 md:w-3/12 text-left pl-2 md:pl-3 py-4">
        <div class="h-4 w-48 bg-gray-200 rounded animate-pulse"></div>
      </th>
      <th class="w-hidden md:table-cell md:w-2/12 py-4"></th>
    </tr>
    </thead>
    <tbody>
      <tr class="border-b border-gray-50 even:bg-gray-50"
        v-for="index in 10" :key="index"
      >
        <td class="w-1/3 md:w-4/12 text-left pl-2 md:pl-3">
          <div class="h-3 bg-gray-100 rounded animate-pulse my-3"></div>
        </td>
        <td class="w-1/3 md:w-3/12 text-left pl-2 md:pl-3">
          <div class="h-3 w-24 bg-gray-100 rounded animate-pulse my-3"></div>
        </td>
        <td class="w-1/3 md:w-3/12 text-left pl-2 md:pl-3">
          <div class="h-3 w-48 bg-gray-100 rounded animate-pulse my-3"></div>
        </td>
        <td class="w-hidden md:table-cell md:w-2/12"></td>
      </tr>
    </tbody>
  </table>
</template>
